export default {
  namespaced: true,
  state: {
    villas: [],
    villasIDs: [],
    maxVillas: 4,
  },
  getters: {
    getViewedVillasIDs: (state) => state.villasIDs,
    getViewedVillas: (state) => state.villas,
  },
  mutations: {
    setViewedVillas: (state, payload) => {
      state.villas = payload;
    },
    setViewedVillasIDs: (state, payload) => {
      state.villasIDs = payload;
      window.$cookies.set('viewedVillas', JSON.stringify(state.villasIDs));
    },
  },
  actions: {
    setStoredData({ state, commit, rootGetters }) {
      const villaCookies = JSON.parse(window.$cookies.get('viewedVillas'));
      const villasIDs = villaCookies && villaCookies.length > 0 ? villaCookies : state.villasIDs;
      commit('setViewedVillasIDs', villasIDs);

      if (villasIDs.length > 0) {
        let results = rootGetters['properties/getAllproperties']?.filter((p) => villasIDs.includes(p.id));
        results = results?.sort((a, b) => villasIDs.indexOf(b.id) - villasIDs.indexOf(a.id));
        commit('setViewedVillas', results);
      }
    },

    addVilla({ state, commit, rootGetters }, villa) {
      const villasCookie = JSON.parse(window.$cookies.get('viewedVillas'));
      const villasIDs = villasCookie && villasCookie.length > 0 ? villasCookie : state.villasIDs;
      villasIDs.push(villa.id);
      const villas = [...new Set([...villasIDs])];

      if (villas.length > state.maxVillas) {
        villas.shift();
      }
      commit('setViewedVillasIDs', villas);

      let results = rootGetters['properties/getAllproperties'].filter((p) => villas.includes(p.id));
      results = results.sort((a, b) => villas.indexOf(b.id) - villas.indexOf(a.id));
      commit('setViewedVillas', results);
    },

    // add all villas to shortlist
    addVillasToShortlist({ state, dispatch }) {
      if (state.villas.length > 0) {
        state.villas.forEach((villa, i) => {
          setTimeout(() => dispatch('common/addShortlist', villa, { root: true }), i * 100);
        });
      }
    },

    // Remove all villas from recently viewed and clear list
    removeAllVillas({ commit }) {
      window.$cookies.set('viewedVillas', '');
      commit('setViewedVillas', []);
      commit('setViewedVillasIDs', []);
    },
  },
};
